import getExtensibilityState from '../store/getExtensibilityState';
import IAddinCommand from '../store/schema/interfaces/IAddinCommand';

/*
    @isAddinCommandBlocked
    Checks if the addinCommand is blocked for given hostItemIndex
*/
const isAddinCommandBlocked = (hostItemIndex: string, addinCommand: IAddinCommand) => {
    const blockedAddinCommands = getExtensibilityState().blockedAddinCommands;
    if (blockedAddinCommands.has(hostItemIndex)) {
        return blockedAddinCommands.get(hostItemIndex).has(addinCommand);
    }
    return false;
};

export default isAddinCommandBlocked;
